import { FirstStepModal } from "./FirstStepModal";
import { SecondStepModal } from "./SecondStepModal";
import React, { FC, useState } from "react";
import { ClassroomOverviewDTO } from "stores/classroomStore_I";

type props = {
	open: boolean;
	onClose: () => void;
};

export const CombineClassesModal: FC<props> = ({ open, onClose }) => {
	const [step, setStep] = useState<1 | 2>(1);
	const [selected, setSelected] = useState<ClassroomOverviewDTO[]>([]);
	const [input, setInput] = useState("");

	const handleClose = () => {
		setStep(1);
		setSelected([]);
		setInput("");
		onClose();
	};

	return (
		<>
			<FirstStepModal
				open={open && step === 1}
				onClose={handleClose}
				onSubmit={() => setStep(2)}
				selected={selected}
				setSelected={setSelected}
			/>
			<SecondStepModal open={open && step === 2} onClose={handleClose} selected={selected} input={input} setInput={setInput} />
		</>
	);
};
